import { MatDialogRef } from '@angular/material';

export class DialogStateModel {
  openDialog: MatDialogRef<any>;
}
